import { fetchListingStages } from '@/api/v4/project-listings.api';
import { QueryKey } from '@/config/query-client';
import { useQueries } from '@tanstack/react-query';
import {
  fetchProjectCreators,
  fetchProjectFiltersTeamOptions,
} from '@/api/v4/project-filters.api';
import { projectsFilterOptionsState } from '../project.state';
import {
  mapListingStatusFilter,
  mapProjectCreatedByFilter,
  mapProjectCreatedForFilter,
} from './project-filters-helpers';
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

export const useFetchProjectFiltersOptions = () => {
  const setProjectFiltersOptions = useSetAtom(projectsFilterOptionsState);
  const staleTime = 5 * 60 * 1000;
  const cacheTime = 5 * 60 * 1000;

  const results = useQueries({
    queries: [
      {
        queryKey: [QueryKey.ListingStages],
        queryFn: () => fetchListingStages(),
        staleTime,
        gcTime: cacheTime,
      },
      {
        queryKey: [QueryKey.ProjectCreators],
        queryFn: () => fetchProjectCreators(),
        staleTime,
        gcTime: cacheTime,
      },
      {
        queryKey: [QueryKey.ProjectFiltersTeamOptions],
        queryFn: () => fetchProjectFiltersTeamOptions(),
        staleTime,
        gcTime: cacheTime,
      },
    ],
  });

  const listingStagesData = results[0].data;
  const projectCreatorsData = results[1].data;
  const teamOptionsData = results[2].data;

  useEffect(() => {
    setProjectFiltersOptions(currentFilters => ({
      ...currentFilters,
      ...(listingStagesData && {
        listingStages: listingStagesData.map(mapListingStatusFilter),
      }),
      ...(projectCreatorsData && {
        createdBy: projectCreatorsData.map(mapProjectCreatedByFilter),
      }),
      ...(teamOptionsData && {
        createdFor: teamOptionsData.map(mapProjectCreatedForFilter),
      }),
    }));
  }, [
    listingStagesData,
    projectCreatorsData,
    teamOptionsData,
    setProjectFiltersOptions,
  ]);

  const isLoading = results.some(result => result.isLoading);

  return {
    isFetchingProjectFilters: isLoading,
  };
};
